export default __webpack_public_path__ + "static/media/cctvimage1.c92ad079.jfif";